// Inspirational and productivity quotes
export const quotes = [
  {
    quote: "The secret of getting ahead is getting started.",
    author: "Mark Twain",
    category: "Productivity"
  },
  {
    quote: "Time is not refundable; use it with intention.",
    author: "Unknown",
    category: "Time Management"
  },
  {
    quote: "Focus on being productive instead of busy.",
    author: "Tim Ferriss",
    category: "Productivity"
  },
  {
    quote: "The way to get started is to quit talking and begin doing.",
    author: "Walt Disney",
    category: "Action"
  },
  {
    quote: "Don't count the days, make the days count.",
    author: "Muhammad Ali",
    category: "Motivation"
  },
  {
    quote: "Success is not final, failure is not fatal: it is the courage to continue that counts.",
    author: "Winston Churchill",
    category: "Success"
  },
  {
    quote: "The future depends on what you do today.",
    author: "Mahatma Gandhi",
    category: "Action"
  },
  {
    quote: "Your time is limited, don't waste it living someone else's life.",
    author: "Steve Jobs",
    category: "Time Management"
  },
  {
    quote: "The only way to do great work is to love what you do.",
    author: "Steve Jobs",
    category: "Passion"
  },
  {
    quote: "Success usually comes to those who are too busy to be looking for it.",
    author: "Henry David Thoreau",
    category: "Success"
  }
];